import { FieldTextProps, FieldWrapper } from '@dixa/lib-shared-habla';

import { CustomFieldAttribute } from 'apis/customFields';

import { CustomFieldSelectAdapter } from '../customFieldSelectAdapter/customFieldSelectAdapter';
import { CustomFieldTextAdapter } from '../customFieldTextAdapter/customFieldTextAdapter';

type CustomFieldFormAdapterProps = {
  attribute: CustomFieldAttribute;
  onAttributeChange: (value: string | readonly string[]) => void;
} & Pick<FieldTextProps, 'prefix' | 'meta' | 'input'>;

// Custom field form adapter between react-form and react-hook-form
export function CustomFieldFormAdapter({
  attribute,
  prefix,
  meta,
  input: { value, name },
  onAttributeChange,
}: CustomFieldFormAdapterProps): JSX.Element {
  return (
    <FieldWrapper noLabel meta={meta}>
      {attribute.type === 'select' ? (
        <CustomFieldSelectAdapter
          attribute={attribute}
          name={name}
          prefix={prefix}
          value={Array.isArray(value) ? value : []}
          onAttributeChange={onAttributeChange}
        />
      ) : (
        <CustomFieldTextAdapter
          attribute={attribute}
          name={name}
          prefix={prefix}
          value={typeof value === 'string' ? value : ''}
          onAttributeChange={onAttributeChange}
        />
      )}
    </FieldWrapper>
  );
}
